import { Grid, Typography } from "@mui/material";
import StatutChip from "components/atoms/Chips/StatutChip";
import type { PropsWithChildren, ReactNode } from "react";
import { Authorization } from "@sdeapps/react-core";
import type { User } from "@sdeapps/react-core";
import type Commande from "models/Commande";
import DisplayMagasinDeRetrait from "./DisplayMagasinDeRetrait";
import DisplayCommandeDate from "./DisplayCommandeDate";
import ApplicationRoles from "constants/ApplicationRoles";
import BarcodeTypography from "components/atoms/BarcodeTypography";

interface SubTitleCommandeProps extends PropsWithChildren {
  demandeur: User | undefined;
  commande: Commande;
}

function SubTitleCommande({
  demandeur,
  commande,
  children,
}: Readonly<SubTitleCommandeProps>): ReactNode {
  return (
    <Grid container spacing={1} size={12}>
      <Grid container size={12} sx={{ alignItems: "center" }} columnSpacing={2}>
        <Authorization roles={ApplicationRoles.STOREMANAGER}>
          <Grid>
            <BarcodeTypography
              variant="barcode2"
              matricule={demandeur?.employeeId}
              sx={{
                display: "inline-block",
                height: "30px",
                verticalAlign: "middle",
                lineHeight: "42px",
              }}
            />
          </Grid>
        </Authorization>
        <Grid>
          <Typography>
            {demandeur?.employeeId ?? "Pas de Matricule"}
            {" • "}
            {demandeur?.jobTitle ?? "Pas de Fonction"}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} size={12}>
        <Grid container size="auto" sx={{ alignItems: "center" }}>
          <Grid size="grow">
            <StatutChip
              sx={{ background: "none", pl: 0 }}
              statut={commande.statutCommande}
              variant="body1"
            />
          </Grid>
        </Grid>

        <DisplayCommandeDate item dateCommande={commande.dateCommande} />
        <DisplayMagasinDeRetrait item magasinDeRetrait={commande.magasinDeRetrait} />

        <Grid size={{ xs: 12, sm: "auto" }} sx={{ textAlign: "end" }}>
          {children}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SubTitleCommande;
